"use client";

import { SpinnerIcon } from "@/components/ui/SpinnerIcon";

export function AuthLoadingFallback() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background">
      <SpinnerIcon size={36} color="hsl(var(--foreground))" />
    </div>
  );
}
